<template>
  <div class="w-full">
    <div class="flex justify-between items-center">
      <Back />
      <router-link 
        :to="'/classroom/' + classroomId + '/detail'"
        class="text-right text-blue-600 hover:text-blue-800 duration-300"
      >
        {{ classroom?.name }} ({{ classroom?.code }})
      </router-link>
    </div>
    <div class="grid grid-cols-1">
      <div>
        <div class="flex justify-between my-3">
          <p class="self-center">Daftar Tugas</p>
          <a
            v-on:click="addNewTask"
            type="button"
            class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white bg-indigo-600 hover:bg-indigo-600 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Tambah Tugas
          </a>
        </div>
        <DataTable
          :value="listTasks"
          class="shadow p-datatable-sm font-sans text-sm"
          responsiveLayout="scroll"
        >
          <template #empty>
            <div class="text-center font-semibold text-red-600">
              Belum ada tugas
            </div>
          </template>
          <template #loading>
            Loading task data. Please wait.
          </template>
          <Column field="name" header="Nama Tugas" sortable></Column>
          <Column field="description" header="Deskripsi Tugas" sortable>
            <template #body="{data}">
              <div v-safe-html="data.description"></div>
            </template>
          </Column>
          <Column field="started_at" header="Dimulai" sortable>
            <template #body="{data}">
              {{ dateFormat(data.started_at) }}
            </template>
          </Column>
          <Column field="expired_at" header="Deadline" sortable>
            <template #body="{data}">
              {{ dateFormat(data.expired_at) }}
            </template>
          </Column>
          <Column field="is_active" header="Aktif" sortable class="capitalize">
            <template #body="{data}">
              <i
                class="far"
                style="font-size:1.75em;"
                :class="
                  data.is_active
                    ? 'fa-check-circle text-green-700'
                    : 'fa-times-circle text-red-700'
                "
              ></i>
            </template>
          </Column>
          <Column field="id" header="Aksi" bodyClass="w-10 space-y-2">
            <template #body="{data}" >
              <button
                @click.prevent="taskEdit(data.id)"
                type="button"
                v-tooltip.top="'Edit'"
                class="w-auto cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm p-2 bg-yellow-500 text-base font-medium text-white hover:bg-yellow-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:w-auto sm:text-sm"
              >
                <i class="fas fa-edit"></i>
              </button>
              <button
                @click.prevent="showDeleteTask(data.id)"
                type="button"
                v-tooltip.top="'Hapus'"
                class="w-auto cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm py-2 px-2.5 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:w-auto sm:text-sm"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
    <!-- modal task -->
    <transition name="pop">
      <div
        v-if="displayModalTask"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
      >
        <div class="relative w-3/4 md:w-1/2 m-auto">
          <div
            class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-85"
          >
            <div
              class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700"
            >
              <h3 class="text-xl font-semibold text-white">
                {{ taskId > 0 ? 'Ubah Tugas' : 'Tambah Tugas' }}
              </h3>
              <button
                class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                v-on:click="closeTask"
              >
                <i
                  class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"
                ></i>
              </button>
            </div>
            <div class="px-6 py-3 overflow-y-auto overflow-x-hidden">
              <div class="w-full pb-3">
                <label
                  for="question"
                  class="block text-sm font-medium text-gray-700"
                >
                  Nama Tugas
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    placeholder="Nama Tugas"
                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    v-model="formTask.name"
                  />
                </div>
              </div>
              <div class="w-full pb-3">
                <label
                  for="question"
                  class="block text-sm font-medium text-gray-700"
                >
                  Deskripsi Tugas
                </label>
                <div class="mt-1">
                  <CKEditor
                    :editor="editor"
                    v-model="formTask.description"
                    :config="editorConfig"
                    class="'w-full"
                  ></CKEditor>
                  <!-- <textarea rows="10" type="text" placeholder="Deskripsi Tugas"
                  class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  v-model="formTask.description"></textarea> -->
                </div>
              </div>

              <div class="w-full pb-3">
                <div class="mt-1">
                  <div class="col-span-6 sm:col-span-3 ">
                    <div class="grid grid-cols-2 gap-2">
                      <div class="w-full">
                        <p class="block text-sm font-medium text-gray-700">
                          Dimulai Tugas
                        </p>
                        <!-- <Calendar id="formTask_started_at" v-model="formTask.started_at" class="w-full" :showTime="true" dateFormat="yy-mm-dd" :showSeconds="true" /> -->
                        <v-date-picker
                          v-model="formTask.started_at"
                          mode="dateTime"
                          @dayclick="changeDateStarted"
                          :attributes="attributesRequestStarted"
                          is24hr
                          :popover="{ placement: 'left' }"
                          :masks="{
                            inputDateTime24hr: 'DD MMMM YYYY HH:mm'
                          }"
                        >
                          <template v-slot="{ inputValue, inputEvents }">
                            <input
                              class="p-2 border rounded focus:outline-none focus:ring-indigo-500  focus:border-indigo-500 w-full text-sm text-gray-700 border-gray-300"
                              :value="inputValue"
                              v-on="inputEvents"
                            />
                          </template>
                        </v-date-picker>
                      </div>

                      <div class="w-full">
                        <p class="block text-sm font-medium text-gray-700">
                          Deadline Tugas
                        </p>
                        <!-- <Calendar id="formTask_expired_at" v-model="formTask.expired_at" class="w-full" :showTime="true" dateFormat="yy-mm-dd" :showSeconds="true" /> -->
                        <v-date-picker
                          v-model="formTask.expired_at"
                          mode="dateTime"
                          @dayclick="changeDateExpired"
                          :attributes="attributesRequestExpired"
                          is24hr
                          :popover="{ placement: 'right' }"
                          :masks="{
                            inputDateTime24hr: 'DD MMMM YYYY HH:mm'
                          }"
                        >
                          <template v-slot="{ inputValue, inputEvents }">
                            <input
                              class="p-2 border rounded focus:outline-none focus:ring-indigo-500  focus:border-indigo-500 w-full text-sm text-gray-700 border-gray-300"
                              :value="inputValue"
                              v-on="inputEvents"
                            />
                          </template>
                        </v-date-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="w-full pb-3">
                <div class="flex items-start">
                  <div class="flex items-center h-5">
                    <input
                      v-model="formTask.is_active"
                      id="isActive"
                      name="isActive"
                      type="checkbox"
                      class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                    />
                  </div>
                  <div class="ml-3 text-sm">
                    <label for="isActive" class="font-medium text-gray-700"
                      >Aktif</label
                    >
                    <p class="text-gray-500">
                      Centang untuk menandakan tugas ini aktif
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-right px-6 py-3">
              <button
                @click.prevent="submitTask"
                class="font-bold inline-flex justify-center text-white border border-solid text-sm px-3 py-1.5 rounded outline-none focus:outline-none"
                :class="
                  taskId > 0
                    ? 'bg-yellow-500 border-yellow-500 hover:bg-yellow-600 active:bg-yellow-600'
                    : 'bg-red-500 border-red-500 hover:bg-red-600 active:bg-red-600'
                "
                type="button"
                style="transition: all .15s ease"
              >
                {{ taskId > 0 ? "Ubah" : "Tambah" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <Delete
      :display="displayDeleteTask"
      title="Delete Tugas?"
      note=""
      :close="closeDeleteTask"
      :deleteBtn="taskDelete"
    />
    <Toast />
  </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue";
import moment from "moment";
import Back from "@/layout/Component/Back";
import Delete from "@/layout/Component/Delete";
import { mapActions, mapGetters } from "vuex";
import { FilterMatchMode } from "primevue/api";

export default {
  components: {
    Back,
    Delete,
    CKEditor: CKEditor.component,
  },

  data() {
    return {
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        toolbar: {
          items: [
            "heading",
            "|",
            "alignment",
            "|",
            "bold",
            "italic",
            "strikethrough",
            "underline",
            "subscript",
            "superscript",
            "|",
            "link",
            "|",
            "bulletedList",
            "numberedList",
            "todoList",
            "fontfamily",
            "fontsize",
            "fontColor",
            "fontBackgroundColor",
            "|",
            "code",
            "codeBlock",
            "|",
            "insertTable",
            "|",
            "outdent",
            "indent",
            "|",
            "uploadImage",
            "blockQuote",
            "|",
            "undo",
            "redo",
          ],
          shouldNotGroupWhenFull: true,
        },
      },
      formTask: {
        name: "",
        description: "",
        short_description: "",
        started_at: "",
        expired_at: "",
        is_active: false,
      },
      displayModal: false,
      filters: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
      classroomId: 0,
      classroomLevelId: 0,
      taskId: 0,
      tasks: null,
      classroomLevel: {},
      displayModalTask: false,
      displayDeleteTask: false,
      whatsNext: "",
      step: 5,
      attributesRequestStarted: [],
      attributesRequestExpired: [],
    };
  },
  async created() {
    this.classroomId = this.$route.params.classroomId;
    this.taskId = this.$route.params.id;
    if (this.classroomId && this.classroom?.id != this.classroomId) {
      await this.getClassroomDetail();
    } else {
      this.next();
    }
    if (
      this.listTasks?.length == 0 ||
      this.classroomId != this.savedIdClassroomTask
    ) {
      const levelId = this.classroom?.levels[0]?.id;
      await this.fetchAllTasks(levelId);
      this.tasks = this.listTasks;
    }
  },
  computed: {
    ...mapGetters([
      "classroom",
      "listTasks",
      "listTasksPagination",
      "task",
      "loadingTask",
      "successTask",
      "messageTask",
      "savedIdTask",
      "savedIdClassroomTask",
    ]),
  },
  methods: {
    ...mapActions([
      "fetchDetailClassroom",
      "fetchAllTasks",
      "fetchDetailTask",
      "addTask",
      "updateTask",
      "deleteTask",
    ]),
    async getClassroomDetail() {
      await this.fetchDetailClassroom(this.classroomId);
      this.next();
    },
    next() {
      if (this.classroom?.must_quizzes_tab) {
        this.whatsNext = "quiz";
      } else {
        this.whatsNext = "";
      }
    },
    nextStep() {
      let confirmation;
      if (!this.webinarList?.length) {
        confirmation = confirm(
          "Tidak ada webinar dalam kelas ini, apakah yakin ingin ke langkah selanjutnya?"
        );
      } else {
        confirmation = confirm("Apakah yakin ingin ke langkah selanjutnya?");
      }
      if (confirmation) {
        if (this.whatsNext != "") {
          this.$router.push(
            "/classroom/" + this.classroom.id + "/step/" + this.whatsNext
          );
        } else {
          this.$router.push("/classroom/" + this.classroom.id + "/detail");
        }
      }
    },

    async getTask() {
      await this.fetchDetailTask(this.taskId);
      this.formTask.name = this.task.name;
      this.formTask.description = this.task.description;
      this.formTask.short_description = this.task.short_description;
      this.formTask.is_active = this.task.is_active;
      this.formTask.started_at = moment(this.task.started_at).format(
        "YYYY-MM-DD HH:mm:00"
      );
      this.formTask.expired_at = moment(this.task.expired_at).format(
        "YYYY-MM-DD HH:mm:00"
      );
      const attrbStarted = [];
      const payloadStarted = {
        key: 1,
        dates: new Date(this.formTask.started_at),
        highlight: true,
      };
      attrbStarted.push(payloadStarted);
      this.attributesRequestStarted = attrbStarted;

      const attrbExpired = [];
      const payloadExpired = {
        key: 1,
        dates: new Date(this.formTask.expired_at),
        highlight: true,
      };
      attrbExpired.push(payloadExpired);
      this.attributesRequestExpired = attrbExpired;
    },
    addNewTask() {
      this.displayModalTask = true;
      this.taskId = null;
      this.formTask.name = "";
      this.formTask.description = "";
      this.formTask.short_description = "";
      this.formTask.started_at = "";
      this.formTask.expired_at = "";
      this.formTask.is_active = false;
      const attrb = [];
      const payload = {
        key: 1,
        dates: new Date(),
        highlight: true,
      };
      attrb.push(payload);
      this.attributesRequestStarted = attrb;
      this.attributesRequestExpired = attrb;
    },
    async taskEdit(id) {
      this.taskId = id;
      await this.getTask();
      this.displayModalTask = true;
    },
    closeTask() {
      this.displayModalTask = false;
      this.taskId = null;
    },
    showDeleteTask(id) {
      this.taskId = id;
      this.displayDeleteTask = true;
    },
    closeDeleteTask() {
      this.taskId = null;
      this.displayDeleteTask = false;
    },
    async taskDelete() {
      await this.deleteTask(this.taskId);
      if (this.successTask) {
        this.closeDeleteTask();
        this.$toast.add({
          severity: "success",
          summary: "Success",
          detail: this.messageTask,
          life: 1000,
        });
        setTimeout(
          () => this.fetchAllTasks(this.classroom?.levels[0]?.id),
          1000
        );
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Failed",
          detail: this.messageTask,
        });
      }
    },
    async submitTask() {
      this.classroomLevelId = this.classroom?.levels[0]?.id;
      if (this.taskId) {
        if (
          this.formTask.name &&
          this.formTask.description &&
          this.formTask.started_at &&
          this.formTask.expired_at
        ) {
          this.formTask.started_at = moment(this.formTask.started_at).format(
            "YYYY-MM-DD HH:mm:00"
          );
          this.formTask.expired_at = moment(this.formTask.expired_at).format(
            "YYYY-MM-DD HH:mm:00"
          );
          if (
            new Date(this.formTask.started_at) >=
            new Date(this.formTask.expired_at)
          ) {
            this.$toast.add({
              severity: "error",
              summary: "Failed Task Date",
              detail:
                "Tanggal berakhir tugas harus lebih besar dari tangal dimulai tugas",
              life: 5000,
            });
            return;
          }
          const task = {
            taskId: this.taskId,
            payload: this.formTask,
          };
          await this.updateTask(task);
          if (this.successTask) {
            this.taskId = null;
            this.fetchAllTasks(this.classroomLevelId);
            this.closeTask();
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.messageTask,
              life: 1000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Failed",
              detail: this.messageTask,
            });
          }
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Nama, Deskripsi, dan Tanggal tugas tidak boleh kosong!",
            life: 3000,
          });
        }
      } else {
        if (
          this.formTask.name &&
          this.formTask.description &&
          this.formTask.started_at &&
          this.formTask.expired_at
        ) {
          this.formTask.started_at = moment(this.formTask.started_at).format(
            "YYYY-MM-DD HH:mm:00"
          );
          this.formTask.expired_at = moment(this.formTask.expired_at).format(
            "YYYY-MM-DD HH:mm:00"
          );
          if (
            new Date(this.formTask.started_at) >=
            new Date(this.formTask.expired_at)
          ) {
            this.$toast.add({
              severity: "error",
              summary: "Failed Task Date",
              detail:
                "Tanggal berakhir tugas harus lebih besar dari tangal dimulai tugas",
              life: 5000,
            });
            return;
          }
          const payload = {
            levelId: this.classroomLevelId,
            payload: this.formTask,
          };
          await this.addTask(payload);
          if (this.successTask) {
            this.fetchAllTasks(this.classroomLevelId);
            this.closeTask();
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.messageTask,
              life: 1000,
            });
            // setTimeout(() => this.$router.go(-1), 1000)
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Failed",
              detail: this.messageTask,
            });
          }
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Nama, Deskripsi, dan Tanggal tugas tidak boleh kosong!",
            life: 3000,
          });
        }
      }
    },
    dateFormat(date) {
      return moment(date)
        .locale("id")
        .format("DD MMMM YYYY HH:mm");
    },
    changeDateStarted(event) {
      const attrb = [];
      const payload = {
        key: 1,
        dates: new Date(event.id),
        highlight: true,
      };
      attrb.push(payload);
      this.attributesRequestStarted = attrb;
    },
    changeDateExpired(event) {
      const attrb = [];
      const payload = {
        key: 1,
        dates: new Date(event.id),
        highlight: true,
      };
      attrb.push(payload);
      this.attributesRequestExpired = attrb;
    },
  },
};
</script>
<style scoped>
::v-deep(.vc-select select) {
  background-image: unset;
}
</style>
